<template>
  <v-navigation-drawer permanent :value="drawer" @input="$emit('update:drawer', $event)" :mini-variant="minimizedDrawer"
    v-if="permissionsLoaded" class="app-drawer" app :color="darkTheme ? '' : 'background'">
    <v-card-actions>
      <v-spacer></v-spacer>
      <!-- @ts-ignore - assets is defined in global mixin -->
      <img @click.stop="toggleMinimized" :src="assets('logos/admin-logo-pixelated.png')" class="clickable" alt="BJJLINK"
        width="40px" height="40px" />
      <v-toolbar-title style="font-weight: 500; letter-spacing: normal; font-size: 16px"
        class="app-title clickable ml-2">Admin +</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!minimizedDrawer" icon @click.stop="toggleMinimized">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </v-card-actions>
    <v-list dense class="text-left app-menu">
      <v-list-item @click.stop="$emit('update:minimizedDrawer', false)">
        <v-list-item-avatar size="25">
          <ImageDisplay :src="$store.state.academyImage" />
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            <AcademySelect></AcademySelect>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link v-if="false && $store.state.inApp" @click="$emit('back-to-bjjlink')">
        <v-list-item-action>
          <v-icon>mdi-chevron-double-left</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("message.back_2_connect")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleHomeClick" :input-value="$route.name === 'home'">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-home-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("message.home") }}</v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item v-allowed="'view_growth_data'" link v-if="$store.state.selectedAcademy"
        @click="handleNav({ name: 'growthcentral' })" :input-value="$route.name === 'growthcentral' || $route.name === 'growthcentraltab'
          ">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-finance</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("message.growth_central")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item v-allowed="'view_members_data'" link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'members' })"
        :input-value="$route.name === 'members' || $route.name === 'memberstab'">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-account-group-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("message.members") }}</v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item v-allowed="'view_attendance'" link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'viewattendance' })" :input-value="$route.name === 'viewattendance' ||
        $route.name === 'viewattendancetab'
        ">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-check-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("message.attendance") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'transactions' })" v-allowed="'view_income'" :input-value="$route.name === 'transactions' || $route.name === 'transactionstab'
        ">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-cash-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("message.transactions") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item v-allowed="'manage_syllabus'" link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'syllabusbuilder' })" :input-value="$route.name === 'syllabusbuilder' ||
        $route.name === 'syllabusbuildertab'
        ">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-school-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> LMS </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'classnotes' })" :input-value="$route.name === 'classnotes' || $route.name === 'classnotestab'
        ">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-clipboard-check-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("message.class_notes") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item v-allowed="'manage_documents'" link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'waivers' })"
        :input-value="$route.name === 'waivers' || $route.name === 'waiverstab'">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-text-box-check-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("message.waivers_documents") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item v-allowed="'view_attendance'" link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'checkins' })" :input-value="$route.name === 'checkins'">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-map-marker-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("message.checkins") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item v-allowed="'view_attendance'" link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'calendar' })" :input-value="$route.name === 'calendar' || $route.name === 'calendartab'
        ">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-calendar-blank-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("message.calendar") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item v-allowed="'view_products'" link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'productstabs', params: { tabId: 0 } })"
        :input-value="$route.name === 'productstabs'">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-shopping-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("message.products_memberships") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item v-allowed="'manage_videos_flowcharts'" link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'flowcharts' })" :input-value="$route.name === 'flowcharts'">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-sitemap-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("message.flowcharts")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item v-allowed="'manage_videos_flowcharts'" link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'videos' })" :input-value="$route.name === 'videos'">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-play-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("message.videos") }}</v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-divider v-if="false"></v-divider>
      <v-list-item link v-if="
        false &&
        !$store.state.inApp &&
        $store.state.selectedAcademy &&
        $store.state.selectedAcademy != 'all'
      " @click="$emit('to-tablet')">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-home-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("message.desk_checkin") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>

      <v-list-item v-allowed="'root'" link v-if="
        $store.state.selectedAcademy && $store.state.selectedAcademy != 'all'
      " @click="handleNav({ name: 'academy' })" :input-value="$route.name === 'academy'" data-v-step="2" id="step-1">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-icon :color="active ? 'black' : 'grey'">mdi-tune-vertical</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("message.academy_info") }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <v-list-item link v-if="$store.state.selectedAcademy && $store.state.isUserLoggedIn"
        @click="$emit('go-to-releases')" :input-value="$route.name === 'releases'" class="mb-6">
        <template v-slot:default="{ active }">
          <v-list-item-action>
            <v-badge style="margin-right: 10px" v-if="$store.state.releasesCount > 0" color="error"
              :content="$store.state.releasesCount" overlap>
              <v-icon :color="active ? 'black' : 'grey'">mdi-cube-outline</v-icon>
            </v-badge>
            <v-icon v-else>mdi-cube-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("message.releases") }}</v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
    </v-list>
    <v-footer v-if="!minimizedDrawer">
      <v-card-text class="text-center">
        <div>
          <IconBjjlink :color="darkTheme ? 'white' : 'black'"></IconBjjlink>
        </div>
        <div>
          <p style="font-size: 12px">{{ $t("message.powered_by") }}</p>
        </div>
        <div><b>MARTIAL ARTS</b> TECHNOLOGY</div>
      </v-card-text>
    </v-footer>
    <div v-else class="text-center mb-3">
      <IconBjjlink style="margin-left: -12px" :size="'25pt'" :color="darkTheme ? 'white' : 'black'"></IconBjjlink>
    </div>
  </v-navigation-drawer>
</template>

<script>
import IconBjjlink from "@/components/displays/icons/IconBjjlink.vue";
import AcademySelect from "@/components/inputs/AcademySelect.vue";
import ImageDisplay from "@/components/displays/ImageDisplay.vue";

export default {
  name: "AppDrawer",
  components: {
    IconBjjlink,
    AcademySelect,
    ImageDisplay,
  },
  props: {
    drawer: {
      type: Boolean,
      default: true,
    },
    minimizedDrawer: {
      type: Boolean,
      default: true,
    },
    permissionsLoaded: {
      type: Boolean,
      default: false,
    },
    darkTheme: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleMinimized() {
      this.$emit("update:minimizedDrawer", !this.minimizedDrawer);
    },
    handleNav(route) {
      this.$emit("navigate", route);
      this.$emit("close-nav");
    },
    handleHomeClick() {
      this.$emit("reload-and-refresh");
      this.$emit("navigate", { name: "home" });
      this.$emit("close-nav");
    },
  },
};
</script>

<style scoped>
.app-drawer {
  overflow-y: hidden;
}

.app-menu {
  overflow-y: auto;
}

.app-title {
  font-family: "Inter";
}

.clickable {
  cursor: pointer;
}
</style>
